// Warenkorb-Komponenten von Monerali (Upsell und Versandschutz).
// Wird auf jeder Seite geladen: Skripte, die mit einem Drawer-Update nachgeladen werden, führt der Browser nicht aus.

// Wartet, bis Shopify.actions bereitsteht (höchstens 5 Sekunden).
const actionsReady = () =>
  new Promise((resolve, reject) => {
    const started = Date.now();
    const check = () => {
      if (window.Shopify?.actions) return resolve();
      if (Date.now() - started > 5000) return reject(new Error('Shopify.actions nicht verfügbar'));
      setTimeout(check, 50);
    };
    check();
  });

if (!customElements.get('monerali-cart-upsell')) {
  const AUTO_KEY = 'monerali-upsell-auto-added';

  customElements.define(
    'monerali-cart-upsell',
    class extends HTMLElement {
      static observedAttributes = ['data-mode', 'data-line-key'];

      connectedCallback() {
        // Delegiert: Der Warenkorb-Drawer baut den Inhalt beim Morphen schrittweise auf,
        // der Button existiert beim Einhängen des Elements eventuell noch nicht.
        if (!this.bound) {
          this.bound = true;
          this.addEventListener('click', (event) => {
            if (event.target instanceof Element && event.target.closest('.cart-upsell__button')) this.add('paid');
          });
        }
        this.run();
      }

      attributeChangedCallback() {
        if (this.isConnected) this.run();
      }

      run() {
        const mode = this.dataset.mode;
        if (mode === 'auto-add') {
          try {
            if (sessionStorage.getItem(AUTO_KEY)) return;
            sessionStorage.setItem(AUTO_KEY, '1');
          } catch (error) {
            if (window.__moneraliAutoAdded) return;
            window.__moneraliAutoAdded = true;
          }
          this.add('set');
        } else if (mode === 'auto-remove' && this.dataset.lineKey) {
          this.remove(this.dataset.lineKey);
        }
      }

      async update(lines) {
        if (this.busy) return;
        this.busy = true;
        try {
          await actionsReady();
          const result = await window.Shopify.actions.updateCart({ lines });
          if (result?.userErrors?.length) console.warn('[cart-upsell]', result.userErrors[0].message);
        } catch (error) {
          console.warn('[cart-upsell] Warenkorb-Update fehlgeschlagen', error);
        } finally {
          this.busy = false;
        }
      }

      add(kind) {
        return this.update([{ merchandiseId: this.dataset.variant, quantity: 1, attributes: [{ key: '_monerali', value: kind }] }]);
      }

      remove(lineKey) {
        try { sessionStorage.removeItem(AUTO_KEY); } catch (error) {}
        return this.update([{ id: lineKey, quantity: 0 }]);
      }
    }
  );
}

if (!customElements.get('monerali-cart-protection')) {
  const PROTECTION_KEY = 'monerali-protection-auto';
  const protectionFlag = (set) => {
    try {
      if (set) sessionStorage.setItem(PROTECTION_KEY, '1');
      return sessionStorage.getItem(PROTECTION_KEY) === '1';
    } catch (error) {
      if (set) window.__moneraliProtectionAuto = true;
      return Boolean(window.__moneraliProtectionAuto);
    }
  };

  customElements.define(
    'monerali-cart-protection',
    class extends HTMLElement {
      static observedAttributes = ['data-mode', 'data-line-key', 'data-quantity'];

      connectedCallback() {
        // Delegiert, weil der Drawer den Inhalt beim Morphen schrittweise aufbaut.
        if (!this.bound) {
          this.bound = true;
          this.addEventListener('change', (event) => {
            if (event.target instanceof HTMLInputElement && event.target.matches('.cart-protection__input')) {
              this.toggle(event.target.checked);
            }
          });
        }
        this.run();
      }

      attributeChangedCallback() {
        if (this.isConnected) this.run();
      }

      run() {
        const { mode, lineKey } = this.dataset;
        if (mode === 'auto-remove' && lineKey) {
          this.update([{ id: lineKey, quantity: 0 }]);
        } else if (mode === 'toggle' && lineKey && Number(this.dataset.quantity) > 1) {
          this.update([{ id: lineKey, quantity: 1 }]);
        } else if (mode === 'toggle' && !lineKey && this.dataset.autoAdd === 'true' && !protectionFlag()) {
          // Vorausgewählt: einmal pro Sitzung dazulegen. Entfernt die Kundin oder der Kunde ihn
          // (Schalter oder Papierkorb), wird er nicht erneut hinzugefügt.
          protectionFlag(true);
          this.add();
        }
      }

      add() {
        return this.update([{ merchandiseId: this.dataset.variant, quantity: 1, attributes: [{ key: '_monerali', value: 'protection' }] }]);
      }

      toggle(on) {
        const { lineKey } = this.dataset;
        protectionFlag(true);
        if (on && !lineKey) {
          this.add();
        } else if (!on && lineKey) {
          this.update([{ id: lineKey, quantity: 0 }]);
        }
      }

      async update(lines) {
        if (this.busy) return;
        this.busy = true;
        this.setAttribute('aria-busy', 'true');
        try {
          await actionsReady();
          const result = await window.Shopify.actions.updateCart({ lines });
          if (result?.userErrors?.length) console.warn('[cart-protection]', result.userErrors[0].message);
        } catch (error) {
          console.warn('[cart-protection] Warenkorb-Update fehlgeschlagen', error);
        } finally {
          this.busy = false;
          this.removeAttribute('aria-busy');
        }
      }
    }
  );
}
